import React from 'react'
import { Dialog, DialogContent, LinearProgress } from '@material-ui/core'

function LoadingEcommerce({ isLoading }) {
  return (
    <Dialog fullWidth open={isLoading} maxWidth="sm">
      <DialogContent style={{ padding: 0 }}>
        <LinearProgress style={{ width: '100%' }} />
      </DialogContent>
    </Dialog>
  )
}

export default LoadingEcommerce
